export default __webpack_public_path__ + "static/media/btn_character_alignment_top.694ca811.svg";